/**
 * API Endpoints Configuration
 * Centralized map of all API endpoint routes used by the application.
 * Organized by domain for maintainability.
 */
export const API_ENDPOINTS = new Map<string, string>();

// =============================================
// SISTEMA / CONFIGURACION GENERAL
// =============================================
API_ENDPOINTS.set('getconfig', '/api/socma/agente/getconfig');
API_ENDPOINTS.set('avilogin', '/api/AVI/LOGIN');
API_ENDPOINTS.set('getdatetime', '/api/PGV/system/getdatetime');

// =============================================
// GESTION
// =============================================
API_ENDPOINTS.set('cargacatalogo', '/api/PGV/GESTION/CARGAR_CATALOGO');
API_ENDPOINTS.set('guardarTipificacionInBound', '/api/PGV/GESTION/GUARDAR_TIPIFICACION_INBOUND');
API_ENDPOINTS.set('getviviendas', '/api/PGV/GESTION/getviviendas');
API_ENDPOINTS.set('gettipocliente', '/api/PGV/GESTION/gettipocliente');
API_ENDPOINTS.set('agregarygestionarcliente', '/api/PGV/GESTION/ADDCLIENTE');
API_ENDPOINTS.set('getProductos', '/api/PGV/GESTION/getProductos');
API_ENDPOINTS.set('obtener_cliente', '/api/PGV/GESTION/OBTENER_CLIENTE');
API_ENDPOINTS.set('obtener_cliente_rellamada', '/api/PGV/GESTION/OBTENER_CLIENTE_RELLAMADA');
API_ENDPOINTS.set('obtener_cliente_volverAllamar', '/api/PGV/GESTION/OBTENER_CLIENTE_VOLVERALLAMAR');
API_ENDPOINTS.set('obtener_cliente_ficha', '/api/PGV/GESTION/OBTENER_CLIENTE_FICHA');
API_ENDPOINTS.set('finalizar_llamada', '/api/PGV/GESTION/FINALIZA_LLAMADA');
API_ENDPOINTS.set('cambio_estado', '/api/PGV/GESTION/CAMBIAR_ESTADO');
API_ENDPOINTS.set('verificaragendamiento', '/api/PGV/GESTION/VERIFICAR_AGENDAMIENTO');
API_ENDPOINTS.set('reagendarytipificar', '/api/PGV/GESTION/REAGENDARYTIPIFICAR');
API_ENDPOINTS.set('creartipologia', '/api/PGV/GESTION/CREAR_GESTION');
API_ENDPOINTS.set('actualizarEstadoContacto', '/api/v1/fib/contactos/actualizar-estado-contacto');
API_ENDPOINTS.set('asegurar_cliente_base', '/api/PGV/CONTACTO/ASEGURAR_BASE');
API_ENDPOINTS.set('historicocampana', '/api/PGV/GESTION/HISTORICO_CAMPANA');
API_ENDPOINTS.set('obtenerbitacora', '/api/PGV/GESTION/OBTENER_BITACORA');
API_ENDPOINTS.set('guardarcomentariobitacora', '/api/PGV/GESTION/GUARDAR_COMENTARIO_BITACORA');
API_ENDPOINTS.set('historicotipologias', '/api/PGV/GESTION/OBTENER_GESTIONES');
API_ENDPOINTS.set('estadisticas_dia', '/api/PGV/GESTION/ESTADISTICA_AGENTE_DIA');
API_ENDPOINTS.set('estadisticas_mes', '/api/PGV/GESTION/ESTADISTICA_AGENTE_MES');
API_ENDPOINTS.set('enviarcorreos', '/api/PGV/GESTION/ENVIARCORREO');
API_ENDPOINTS.set('getgestionespv', '/api/PGV/GESTION/PAGINEO_GESTIONES_POSTVENTA');
API_ENDPOINTS.set('getgestionespvcount', '/api/PGV/GESTION/CONTEO_GESTIONES_POSTVENTA');
API_ENDPOINTS.set('ejecutadoscount', '/api/PGV/GESTION/CONTEO_GESTIONES_POSTVENTA_EJECUTADOS');
API_ENDPOINTS.set('noejecutadoscount', '/api/PGV/GESTION/CONTEO_GESTIONES_POSTVENTA_NOEJECUTADOS');
API_ENDPOINTS.set('actualizargestion', '/api/PGV/GESTION/ACTUALIZAR_GESTION_POSTVENTA');
API_ENDPOINTS.set('reportepostventa', '/api/PGV/GESTION/OBTENER_REPORTE_POSTVENTA');
API_ENDPOINTS.set('descargagestion', '/api/PGV/GESTION/DESCARGA_GESTIONES_POSTVENTA');

// =============================================
// CAMPANA
// =============================================
API_ENDPOINTS.set('prevlista', '/api/PGV/CAMPANA/GET_PREV_LISTA');
API_ENDPOINTS.set('deleteclientelista', '/api/PGV/CAMPANA/DELETE_CLIENTE_LISTA');
API_ENDPOINTS.set('agentecampanalite', '/api/PGV/CAMPANA/GET_AGENTES');
API_ENDPOINTS.set('campanasactivas', '/api/PGV/CAMPANA/CAMPANAS_ACTIVAS');
API_ENDPOINTS.set('createcampana', '/api/PGV/CAMPANA/CREAR');
API_ENDPOINTS.set('setautorizacioncamp', '/api/PGV/CAMPANA/SETAUTORIZACION');
API_ENDPOINTS.set('getcampana', '/api/PGV/CAMPANA/PAGINEO');
API_ENDPOINTS.set('getcampanacount', '/api/PGV/CAMPANA/CONTEO');
API_ENDPOINTS.set('modifyCampana', '/api/PGV/CAMPANA/MODIFICAR');
API_ENDPOINTS.set('getcampanasemaforo', '/api/PGV/CAMPANA/SEMAFORO');
API_ENDPOINTS.set('getcampanasemaforoclientes', '/api/PGV/CAMPANA/SEMAFORO/CLIENTES');
API_ENDPOINTS.set('getcampanasemaforoclientesporcampana', '/api/PGV/CAMPANA/SEMAFORO/CLIENTES/CAMPANA');
API_ENDPOINTS.set('listacampanas', '/api/PGV/CAMPANA/LISTAR');
API_ENDPOINTS.set('historialEstadosListar', '/api/PGV/ORDENES/HISTORIAL_ESTADOS/LISTAR');
API_ENDPOINTS.set('nuevasOrdenesSinCitaListar', '/api/PGV/ORDENES/NUEVAS_SIN_CITA/LISTAR');
API_ENDPOINTS.set('locksListar', '/api/PGV/LOCKS/LISTAR');
API_ENDPOINTS.set('locksForceRelease', '/api/PGV/LOCKS/FORCE_RELEASE');
API_ENDPOINTS.set('filtrarclicamp', '/api/PGV/CAMPANA/FILTRAR_CLIENTES_CAMPANA');
API_ENDPOINTS.set('pagineoclienteinvalido', '/api/PGV/CAMPANA/PAGINEO_CLIREPCAMP');
API_ENDPOINTS.set('lotepagineoclienteinvalido', '/api/PGV/CAMPANA/LOTE_PAGINEO_CLIREPCAMP');
API_ENDPOINTS.set('conteoclienteinvalido', '/api/PGV/CAMPANA/CONTEO_CLIREPCAMP');
API_ENDPOINTS.set('getcampanaaut', '/api/PGV/CAMPANA/PAGINEO_AUT');
API_ENDPOINTS.set('getcampanacountaut', '/api/PGV/CAMPANA/CONTEO_AUT');
API_ENDPOINTS.set('upsertwhatsapp', '/api/PGV/CAMPANA/UPSERTWHATSAPP');
API_ENDPOINTS.set('getmsjwhatsapp', '/api/PGV/CAMPANA/GETMSJWHATSAPP');
API_ENDPOINTS.set('gettipo', '/api/PGV/CAMPANA/GETTIPOLOGIAS');
API_ENDPOINTS.set('getsubtipo', '/api/PGV/CAMPANA/GETSUBTIPOLOGIAS');
API_ENDPOINTS.set('insertcanalesdig', '/api/PGV/CAMPANA/INSERTCANALESDIG');
API_ENDPOINTS.set('getcanalesdig', '/api/PGV/CAMPANA/GETCANALESDIG');
API_ENDPOINTS.set('getreglaoport', '/api/PGV/CAMPANA/GETREGLAOPORT');
API_ENDPOINTS.set('insertgestoroportunidad', '/api/PGV/CAMPANA/INSERT_REGLAOPORT');
API_ENDPOINTS.set('getgestoroportunidad', '/api/PGV/CAMPANA/GET_REGLAOPORT');
API_ENDPOINTS.set('desasignarlista', '/api/PGV/CAMPANA/DESASIGNAR_LISTA');
API_ENDPOINTS.set('deletelistacampana', '/api/PGV/CAMPANA/BORRAR_LISTA');
API_ENDPOINTS.set('listaexistente', '/api/PGV/CAMPANA/LISTA_EXISTENTE');
API_ENDPOINTS.set('exportarlista', '/api/PGV/CAMPANA/EXPORTAR_LISTA');
API_ENDPOINTS.set('exportarlistalote', '/api/PGV/CAMPANA/EXPORTAR_LISTA_LOTE');
API_ENDPOINTS.set('exportarlistacount', '/api/PGV/CAMPANA/EXPORTAR_LISTA_COUNT');
API_ENDPOINTS.set('deletecampana', '/api/PGV/CAMPANA/BORRAR');
API_ENDPOINTS.set('asignaragente', '/api/PGV/CAMPANA/ASIGNAR_AGENTE');
API_ENDPOINTS.set('getencabezados', '/api/PGV/CAMPANA/GETENCABEZADOS');
API_ENDPOINTS.set('duplicarcampana', '/api/PGV/CAMPANA/DUPLICAR');
API_ENDPOINTS.set('getagencias', '/api/PGV/CAMPANA/GETAGENCIAS');
API_ENDPOINTS.set('distribuirclientes', '/api/PGV/CAMPANA/DISTRIBUIRCLIENTES');
API_ENDPOINTS.set('validatraslapecampana', '/api/PGV/CAMPANA/VALIDA_TRASLAPE_CAMPANA');
API_ENDPOINTS.set('validatraslapehorariocampana', '/api/PGV/CAMPANA/VALIDA_TRASLAPE_HORARIO_CAMPANA');
API_ENDPOINTS.set('getcampanapvbo', '/api/PGV/CAMPANA/PAGINEOPOSTVENTABO');

// CAMPANA ADMIN
API_ENDPOINTS.set('createcampanaadmin', '/api/PGV/CAMPANA/ADMIN/CREAR');
API_ENDPOINTS.set('getcampanaadmin', '/api/PGV/CAMPANA/ADMIN/PAGINEO');
API_ENDPOINTS.set('getcampanaadmincount', '/api/PGV/CAMPANA/ADMIN/CONTEO');
API_ENDPOINTS.set('crearcampanaxcontrata', '/api/PGV/CAMPANA/ADMIN/REPLICAR');
API_ENDPOINTS.set('editarcampanaxcontrata', '/api/PGV/CAMPANA/ADMIN/EDITAR/REPLICAR');
API_ENDPOINTS.set('editarfiltrodistclientes', '/api/PGV/CAMPANA/ADMIN/EDITAR/FILTRODISTCLI');
API_ENDPOINTS.set('agenciascampana', '/api/PGV/CAMPANA/ADMIN/AGENCIAS_CAMPANA');
API_ENDPOINTS.set('provinciascampana', '/api/PGV/CAMPANA/ADMIN/PROVINCIAS_CAMPANA');
API_ENDPOINTS.set('gettotalescampanasadmin', '/api/PGV/CAMPANA/ADMIN/TOTALES');
API_ENDPOINTS.set('exportarlistaadminlote', '/api/PGV/CAMPANA/ADMIN/EXPORTAR_LISTA_LOTE');
API_ENDPOINTS.set('exportarlistaadmincount', '/api/PGV/CAMPANA/ADMIN/EXPORTAR_LISTA_COUNT');

// =============================================
// AGENTE
// =============================================
API_ENDPOINTS.set('campanacatalogo', '/api/PGV/AGENTE/PAGINEO_CAMPANA_CATALOGO');
API_ENDPOINTS.set('tablecampanacatalogo', '/api/PGV/AGENTE/PAGINEO_CATALOGO_AGENTE');
API_ENDPOINTS.set('tablecampanacatalogocount', '/api/PGV/AGENTE/PAGINEO_CATALOGO_AGENTE_COUNT');
API_ENDPOINTS.set('getagente', '/api/PGV/AGENTE/PAGINEO');
API_ENDPOINTS.set('getagenteagente', '/api/PGV/AGENTE/PAGINEO_AGENTE');
API_ENDPOINTS.set('getagentecount', '/api/PGV/AGENTE/CONTEO');
API_ENDPOINTS.set('createagente', '/api/PGV/AGENTE/CREAR');
API_ENDPOINTS.set('editagente', '/api/PGV/AGENTE/MODIFICAR');
API_ENDPOINTS.set('deleteagente', '/api/PGV/AGENTE/BORRAR');
API_ENDPOINTS.set('loginagente', '/api/AGENTE/LOGIN');
API_ENDPOINTS.set('ssoexchange', '/api/AGENTE/SSO/EXCHANGE');
API_ENDPOINTS.set('updateWhatsapp', '/api/AGENTE/getwhatsappqr');
API_ENDPOINTS.set('setSincronizar', '/api/AGENTE/setSincronizar');
API_ENDPOINTS.set('asignarcampana', '/api/PGV/AGENTE/ASIGNAR_CAMPANA');
API_ENDPOINTS.set('campanasagente', '/api/PGV/AGENTE/CAMPANAS_AGENTE');
API_ENDPOINTS.set('saveMsgWhatsapp', '/api/PGV/AGENTE/SAVEMSGWHATSAPP');
API_ENDPOINTS.set('getprovincias', '/api/PGV/AGENTE/GETPROVINCIAS');
API_ENDPOINTS.set('getdistritosxprovincia', '/api/PGV/AGENTE/GETDISTRITOSXPROVINCIA');
API_ENDPOINTS.set('getcorregimientosxdistrito', '/api/PGV/AGENTE/GETCORREGIMIENTOSXDISTRITO');
API_ENDPOINTS.set('getprovinciasxagente', '/api/PGV/AGENTE/GETPROVINCIASXAGENTE');
API_ENDPOINTS.set('getAreasAgente', '/api/PGV/AGENTE/getAreasAgente');
API_ENDPOINTS.set('getContrata', '/api/PGV/AGENTE/getContrata');
API_ENDPOINTS.set('getcorregimientos', '/api/PGV/AGENTE/getcorregimientos');
API_ENDPOINTS.set('histllamadasagente', '/api/PGV/AGENTE/HIST_LLAMADA_AGENTE');
API_ENDPOINTS.set('histllamadasagentecount', '/api/PGV/AGENTE/HIST_LLAMADA_AGENTE_COUNT');
API_ENDPOINTS.set('rellamadasagente', '/api/PGV/AGENTE/RELLAMADA_AGENTE');
API_ENDPOINTS.set('rellamadasagentecount', '/api/PGV/AGENTE/RELLAMADA_AGENTE_COUNT');
API_ENDPOINTS.set('cambiapass', '/api/PGV/AGENTE/CAMBIA_PASS');
API_ENDPOINTS.set('cargamasivaagentes', '/api/PGV/AGENTE/CARGA_MASIVA');
API_ENDPOINTS.set('eliminamasivaagentes', '/api/PGV/AGENTE/ELIMINA_MASIVA');
API_ENDPOINTS.set('asignamasivaagentes', '/api/PGV/AGENTE/ASIGNA_CAMPANA_MASIVA');
API_ENDPOINTS.set('habilitaragente', '/api/PGV/AGENTE/HABILITAR');
API_ENDPOINTS.set('historicoagente', '/api/PGV/AGENTE/HISTORICO_AGENTE');
API_ENDPOINTS.set('editagentehistorico', '/api/PGV/AGENTE/HISTORICO_AGENTE_EDIT');
API_ENDPOINTS.set('historicoagenterol', '/api/PGV/AGENTE/HISTORICO_AGENTE_ROL');
API_ENDPOINTS.set('gethorariosagente', '/api/PGV/AGENTE/HORARIO_AGENTE');
API_ENDPOINTS.set('toggleDistribuidorTecnico', '/api/PGV/AGENTE/TOGGLE_DISTRIBUIDOR');
API_ENDPOINTS.set('getDistribuidoresTecnico', '/api/PGV/AGENTE/GET_DISTRIBUIDORES_TECNICO');

// ADMIN AGENTE
API_ENDPOINTS.set('getadminagente', '/api/PGV/ADMIN/AGENTE/PAGINEO');
API_ENDPOINTS.set('getadminagentecount', '/api/PGV/ADMIN/AGENTE/CONTEO');
API_ENDPOINTS.set('getadminagentecontrata', '/api/PGV/ADMIN/AGENTE/CONTRATA');

// =============================================
// SUPERVISOR
// =============================================
API_ENDPOINTS.set('supervisorcampana', '/api/PGV/SUPERVISOR/CAMPANAS');
API_ENDPOINTS.set('agentecampana', '/api/PGV/SUPERVISOR/AGENTES');
API_ENDPOINTS.set('horascampana', '/api/PGV/SUPERVISOR/HORACAMPANA');
API_ENDPOINTS.set('diacampana', '/api/PGV/SUPERVISOR/DIACAMPANA');
API_ENDPOINTS.set('excelrellamadas', '/api/PGV/SUPERVISOR/EXCEL_RELLAMADA_CAMPANA');
API_ENDPOINTS.set('rellamadas', '/api/PGV/SUPERVISOR/RELLAMADA_CAMPANA');
API_ENDPOINTS.set('rellamadascount', '/api/PGV/SUPERVISOR/RELLAMADA_CAMPANA_COUNT');
API_ENDPOINTS.set('pivotsupervisor', '/api/PGV/SUPERVISOR/DASHBOARD_PIVOT');
API_ENDPOINTS.set('monitordeagentes', '/api/PGV/SUPERVISOR/MONITOR_AGENTE');

// =============================================
// TIPOLOGIA
// =============================================
API_ENDPOINTS.set('get_tipologias', '/api/PGV/TIPOLOGIA/TIPOLOGIAS');
API_ENDPOINTS.set('get_subtipologias', '/api/PGV/TIPOLOGIA/SUBTIPOLOGIAS');
API_ENDPOINTS.set('gettipologia', '/api/PGV/TIPOLOGIA/PAGINEO');
API_ENDPOINTS.set('gettipologiacount', '/api/PGV/TIPOLOGIA/CONTEO');
API_ENDPOINTS.set('createtipologia', '/api/PGV/TIPOLOGIA/CREAR');
API_ENDPOINTS.set('edittipologia', '/api/PGV/TIPOLOGIA/MODIFICAR');
API_ENDPOINTS.set('deletetipologia', '/api/PGV/TIPOLOGIA/BORRAR');
API_ENDPOINTS.set('getsubtipologias', '/api/PGV/TIPOLOGIA/SUBTIPOLOGIAS');
API_ENDPOINTS.set('camposextracep', '/api/PGV/TIPOLOGIA/CAMPOS_EXTRAS_CEP');

// =============================================
// CICLO DE VIDA
// =============================================
API_ENDPOINTS.set('createciclo', '/api/PGV/CICLOVIDA/CREAR');
API_ENDPOINTS.set('obtenerciclo', '/api/PGV/CICLOVIDA/OBTENER');
API_ENDPOINTS.set('cleanciclo', '/api/PGV/CICLOVIDA/LIMPIAR');

// =============================================
// ALARMA
// =============================================
API_ENDPOINTS.set('cleanalarma', '/api/PGV/ALARMA/BORRAR');
API_ENDPOINTS.set('createalarma', '/api/PGV/ALARMA/CREAR');
API_ENDPOINTS.set('obteneralarma', '/api/PGV/ALARMA/OBTENER');

// =============================================
// HORARIO
// =============================================
API_ENDPOINTS.set('obtenerhorario', '/api/PGV/HORARIO/OBTENER');
API_ENDPOINTS.set('createschedule', '/api/PGV/HORARIO/CREAR');

// =============================================
// EJE
// =============================================
API_ENDPOINTS.set('createeje', '/api/PGV/EJE/CREAR');
API_ENDPOINTS.set('geteje', '/api/PGV/EJE/PAGINEO');
API_ENDPOINTS.set('getejecount', '/api/PGV/EJE/CONTEO');
API_ENDPOINTS.set('editeje', '/api/PGV/EJE/MODIFICAR');
API_ENDPOINTS.set('deleteeje', '/api/PGV/EJE/BORRAR');

// =============================================
// ROL
// =============================================
API_ENDPOINTS.set('getrol', '/api/PGV/ROL/PAGINEO');
API_ENDPOINTS.set('getrolcount', '/api/PGV/ROL/CONTEO');
API_ENDPOINTS.set('createrol', '/api/PGV/ROL/CREAR');
API_ENDPOINTS.set('editrol', '/api/PGV/ROL/MODIFICAR');
API_ENDPOINTS.set('deleterol', '/api/PGV/ROL/BORRAR');
API_ENDPOINTS.set('listaroles', '/api/PGV/ROL/LISTAR');

// =============================================
// PXA
// =============================================
API_ENDPOINTS.set('getpxa', '/api/PGV/PXA/PAGINEO');
API_ENDPOINTS.set('getpxacount', '/api/PGV/PXA/CONTEO');
API_ENDPOINTS.set('createpxa', '/api/PGV/PXA/CREAR');
API_ENDPOINTS.set('editpxa', '/api/PGV/PXA/MODIFICAR');
API_ENDPOINTS.set('deletepxa', '/api/PGV/PXA/BORRAR');
API_ENDPOINTS.set('cargamasivapxa', '/api/PGV/PXA/CARGA_MASIVA');
API_ENDPOINTS.set('simularpxa', '/api/PGV/PXA/SIMULAR');
API_ENDPOINTS.set('auditoriapxa', '/api/PGV/PXA/AUDITORIA');

// =============================================
// RECORDATORIO
// =============================================
API_ENDPOINTS.set('obtenerrecordatorios', '/api/PGV/RECORDATORIO/OBTENER');
API_ENDPOINTS.set('modificarrecordatorio', '/api/PGV/RECORDATORIO/MODIFICAR');

// =============================================
// CRITERIO
// =============================================
API_ENDPOINTS.set('listacolumnas', '/api/PGV/CRITERIO/LISTAR_COLUMNAS');
API_ENDPOINTS.set('asignarcriterios', '/api/PGV/CRITERIO/ASIGNAR');
API_ENDPOINTS.set('obtenercriterios', '/api/PGV/CRITERIO/OBTENER_CRITERIOS');

// =============================================
// ENTREVISTA
// =============================================
API_ENDPOINTS.set('getentrevista', '/api/PGV/ENTREVISTA/PAGINEO');
API_ENDPOINTS.set('getentrevistacount', '/api/PGV/ENTREVISTA/CONTEO');
API_ENDPOINTS.set('createentrevista', '/api/PGV/ENTREVISTA/CREAR');
API_ENDPOINTS.set('editentrevista', '/api/PGV/ENTREVISTA/MODIFICAR');
API_ENDPOINTS.set('deleteentrevista', '/api/PGV/ENTREVISTA/BORRAR');
API_ENDPOINTS.set('getsubentrevistas', '/api/PGV/ENTREVISTA/SUBENTREVISTAS');
API_ENDPOINTS.set('get_entrevistas', '/api/PGV/ENTREVISTA/ENTREVISTAS');
API_ENDPOINTS.set('get_subentrevistas', '/api/PGV/ENTREVISTA/SUBENTREVISTAS');

// =============================================
// TIPIFICACION RECOLECTOR
// =============================================
API_ENDPOINTS.set('gettipologiare', '/api/PGV/TIPIFICACION/RECOLECTOR/PAGINEO');
API_ENDPOINTS.set('gettipologiarecount', '/api/PGV/TIPIFICACION/RECOLECTOR/CONTEO');
API_ENDPOINTS.set('createtipologiare', '/api/PGV/TIPIFICACION/RECOLECTOR/CREAR');
API_ENDPOINTS.set('edittipologiare', '/api/PGV/TIPIFICACION/RECOLECTOR/MODIFICAR');
API_ENDPOINTS.set('deletetipologiare', '/api/PGV/TIPIFICACION/RECOLECTOR/BORRAR');
API_ENDPOINTS.set('getsubtipologiare', '/api/PGV/TIPIFICACION/RECOLECTOR/SUBTIPOLOGIAS');
API_ENDPOINTS.set('get_tipologiasre', '/api/PGV/TIPIFICACION/RECOLECTOR/TIPOLOGIAS');
API_ENDPOINTS.set('get_subtipologiasre', '/api/PGV/TIPIFICACION/RECOLECTOR/SUBTIPOLOGIAS');

// =============================================
// CLIENTE
// =============================================
API_ENDPOINTS.set('getdataclient', '/api/PGV/CLIENTE/GETDATACLIENT');
API_ENDPOINTS.set('deleteTareaProgramada', '/api/PGV/CLIENTE/deleteTareaProgramada');
API_ENDPOINTS.set('buscarcliente', '/api/PGV/CLIENTE/BUSCARCLIENTE');
API_ENDPOINTS.set('getservicioscli', '/api/PGV/CLIENTE/GETSERVICIOS');
API_ENDPOINTS.set('getproductoscli', '/api/PGV/CLIENTE/GETPRODUCTOS');
API_ENDPOINTS.set('gettoken', '/api/PGV/CLIENTE/GETTOKEN');
API_ENDPOINTS.set('actualizarcliente', '/api/PGV/cliente/update');
API_ENDPOINTS.set('actualizarfalla', '/api/PGV/cliente/updateFalla');

// =============================================
// DISTRIBUIDOR
// =============================================
API_ENDPOINTS.set('getdistribuidorxcampanapadre', '/api/PGV/DISTRIBUIDOR/ASIGCAMPANAPADRE');
API_ENDPOINTS.set('getdistribuidor', '/api/PGV/DISTRIBUIDOR/PAGINEO');
API_ENDPOINTS.set('getdistribuidorcount', '/api/PGV/DISTRIBUIDOR/CONTEO');
API_ENDPOINTS.set('createdistribuidor', '/api/PGV/DISTRIBUIDOR/CREAR');
API_ENDPOINTS.set('editdistribuidor', '/api/PGV/DISTRIBUIDOR/MODIFICAR');
API_ENDPOINTS.set('setestadodistribuidor', '/api/PGV/DISTRIBUIDOR/SETESTADO');
API_ENDPOINTS.set('getcapacidad', '/api/PGV/DISTRIBUIDOR/GETCAPACITY');
API_ENDPOINTS.set('getcapacidadxprovincia', '/api/PGV/DISTRIBUIDOR/GETCAPACITYXPROVINCIA');
API_ENDPOINTS.set('getcapacidadxtipotecnico', '/api/PGV/DISTRIBUIDOR/GETCAPACITYXTIPOTECNICO');
API_ENDPOINTS.set('modificarcapacidad', '/api/PGV/DISTRIBUIDOR/MODIFYCAPACITY');
API_ENDPOINTS.set('modificarcapacidadxprovincia', '/api/PGV/DISTRIBUIDOR/MODIFYCAPACITYXPROVINCIA');
API_ENDPOINTS.set('modificarcapacidadxtipotecnico', '/api/PGV/DISTRIBUIDOR/MODIFYCAPACITYXTIPOTECNICO');
API_ENDPOINTS.set('gettecnicos', '/api/PGV/DISTRIBUIDOR/GETTECNICO');
API_ENDPOINTS.set('getcitas', '/api/PGV/DISTRIBUIDOR/GETCITAS');
API_ENDPOINTS.set('actualizarcitasporagente', '/api/PGV/DISTRIBUIDOR/ACTUALIZARCITAS');
API_ENDPOINTS.set('getconfig2xarea', '/api/PGV/DISTRIBUIDOR/getconfig2xarea');
API_ENDPOINTS.set('modifyconfig2xarea', '/api/PGV/DISTRIBUIDOR/modifyconfig2xarea');
API_ENDPOINTS.set('getconfig2xareaHist', '/api/PGV/DISTRIBUIDOR/getconfig2xareaHist');

// =============================================
// ADMIN-SUPERVISOR
// =============================================
API_ENDPOINTS.set('getadminsupervisor', '/api/PGV/ADMINSUPER/PAGINEO');
API_ENDPOINTS.set('getadminsupervisorcount', '/api/PGV/ADMINSUPER/CONTEO');
API_ENDPOINTS.set('creatadminsupervisor', '/api/PGV/ADMINSUPER/CREAR');
API_ENDPOINTS.set('editadminsupervisor', '/api/PGV/ADMINSUPER/MODIFICAR');
API_ENDPOINTS.set('setestadoadminsupervisor', '/api/PGV/ADMINSUPER/SETESTADO');

// =============================================
// ADMINISTRADOR
// =============================================
API_ENDPOINTS.set('getadministrador', '/api/PGV/ADMINISTRADOR/PAGINEO');
API_ENDPOINTS.set('getadministradorcount', '/api/PGV/ADMINISTRADOR/CONTEO');
API_ENDPOINTS.set('createadministrador', '/api/PGV/ADMINISTRADOR/CREAR');
API_ENDPOINTS.set('editadministrador', '/api/PGV/ADMINISTRADOR/MODIFICAR');
API_ENDPOINTS.set('setestadoadministrador', '/api/PGV/ADMINISTRADOR/SETESTADO');

// =============================================
// RECOLECTOR DE EQUIPOS
// =============================================
API_ENDPOINTS.set('getrecolector', '/api/PGV/RECOLECTOR/PAGINEO');
API_ENDPOINTS.set('getrecolectorcount', '/api/PGV/RECOLECTOR/CONTEO');
API_ENDPOINTS.set('createrecolector', '/api/PGV/RECOLECTOR/CREAR');
API_ENDPOINTS.set('editrecolector', '/api/PGV/RECOLECTOR/MODIFICAR');
API_ENDPOINTS.set('setestadorecolector', '/api/PGV/RECOLECTOR/SETESTADO');

// =============================================
// AREA
// =============================================
API_ENDPOINTS.set('getallarea', '/api/PGV/AREA/ALL');
API_ENDPOINTS.set('getarea', '/api/PGV/AREA/PAGINEO');
API_ENDPOINTS.set('getareacount', '/api/PGV/AREA/CONTEO');
API_ENDPOINTS.set('createarea', '/api/PGV/AREA/CREAR');
API_ENDPOINTS.set('editarea', '/api/PGV/AREA/MODIFICAR');
API_ENDPOINTS.set('setestadoarea', '/api/PGV/AREA/SETESTADO');

// =============================================
// EDIFICIO
// =============================================
API_ENDPOINTS.set('getalledificio', '/api/PGV/EDIFICIO/ALL');
API_ENDPOINTS.set('getedificio', '/api/PGV/EDIFICIO/PAGINEO');
API_ENDPOINTS.set('getedificiocount', '/api/PGV/EDIFICIO/CONTEO');
API_ENDPOINTS.set('createedificio', '/api/PGV/EDIFICIO/CREAR');
API_ENDPOINTS.set('editedificio', '/api/PGV/EDIFICIO/MODIFICAR');
API_ENDPOINTS.set('setestadoedificio', '/api/PGV/EDIFICIO/SETESTADO');
API_ENDPOINTS.set('gethorariosedif', '/api/PGV/EDIFICIO/HORARIOS');
API_ENDPOINTS.set('deletehorarioedif', '/api/PGV/EDIFICIO/DELETEHORARIO');
API_ENDPOINTS.set('updatehorarioedif', '/api/PGV/EDIFICIO/UPDATEHORARIO');

// =============================================
// MENSAJERIA
// =============================================
API_ENDPOINTS.set('getlistacampana', '/api/PGV/mensajeria/campana/lista');
API_ENDPOINTS.set('getcriteriocatalogo', '/api/PGV/mensajeria/catalogo');
API_ENDPOINTS.set('getcriteriolista', '/api/PGV/mensajeria/catalogo/lista');
API_ENDPOINTS.set('getmensajerias', '/api/PGV/mensajeria');
API_ENDPOINTS.set('getmensajeriadetalle', '/api/PGV/mensajeria/detalle');
API_ENDPOINTS.set('upsertmensajeria', '/api/PGV/mensajeria/save');
API_ENDPOINTS.set('deletemensajeria', '/api/PGV/mensajeria/delete');
API_ENDPOINTS.set('getarchivomensajeria', '/api/PGV/mensajeria/getArchivo');

// =============================================
// RAZON ALARMA
// =============================================
API_ENDPOINTS.set('getrazon', '/api/PGV/RAZONALARMA/PAGINEO');
API_ENDPOINTS.set('getrazoncount', '/api/PGV/RAZONALARMA/CONTEO');
API_ENDPOINTS.set('createrazon', '/api/PGV/RAZONALARMA/CREAR');
API_ENDPOINTS.set('editrazon', '/api/PGV/RAZONALARMA/MODIFICAR');
API_ENDPOINTS.set('deleterazon', '/api/PGV/RAZONALARMA/BORRAR');
API_ENDPOINTS.set('listarazon', '/api/PGV/RAZONALARMA/LISTAR');

// =============================================
// REGLA
// =============================================
API_ENDPOINTS.set('modificarregla', '/api/PGV/REGLA/MODIFICAR');
API_ENDPOINTS.set('obtenerregla', '/api/PGV/REGLA/OBTENER');
API_ENDPOINTS.set('obtenerareadeagente', '/api/PGV/REGLA/GET_AREA_DE_AGENTE');
API_ENDPOINTS.set('obtenerareadedistribuidor', '/api/PGV/REGLA/GET_AREA_DE_DISTRIBUIDOR');

// =============================================
// CITAS PROGRAMADAS
// =============================================
API_ENDPOINTS.set('getcitasprogramadas', '/api/PGV/CITAS/PROGRAMADAS/getpagineo');
API_ENDPOINTS.set('getcitasprogramadasdescarga', '/api/PGV/CITAS/PROGRAMADAS/getpagineodescarga');
API_ENDPOINTS.set('getcountcitasprogramadas', '/api/PGV/CITAS/PROGRAMADAS/getcount');
API_ENDPOINTS.set('updatecitaprogramada', '/api/PGV/CITAS/PROGRAMADAS/update');
API_ENDPOINTS.set('histcitaprogramada', '/api/PGV/CITAS/PROGRAMADAS/historial');
API_ENDPOINTS.set('gettecnicosxcontrata', '/api/PGV/CITAS/PROGRAMADAS/gettecnicosxcontrata');
API_ENDPOINTS.set('editarcuentacita', '/api/PGV/CITAS/PROGRAMADAS/editarcuenta');
API_ENDPOINTS.set('liberarcita', '/api/PGV/CITAS/PROGRAMADAS/liberar');
API_ENDPOINTS.set('riesgozonadetalle', '/api/PGV/CITAS/PROGRAMADAS/riesgozonadetalle');
API_ENDPOINTS.set('getestadoscita', '/api/PGV/CITAS/PROGRAMADAS/getestados');

// =============================================
// CITAS SIN COORDENADAS
// =============================================
API_ENDPOINTS.set('listarCitasSinCoordenadas', '/api/PGV/CITAS/SIN_COORDENADAS/LISTAR');
API_ENDPOINTS.set('countCitasSinCoordenadas', '/api/PGV/CITAS/SIN_COORDENADAS/COUNT');
API_ENDPOINTS.set('capturarCoordsCita', '/api/PGV/CITAS/SIN_COORDENADAS/CAPTURAR_COORDS');

// =============================================
// CITAS SUSPENDIDAS
// =============================================
API_ENDPOINTS.set('getcitassuspendidas', '/api/PGV/CITAS/SUSPENDIDAS/getpagineo');
API_ENDPOINTS.set('getcitassuspendidasdescarga', '/api/PGV/CITAS/SUSPENDIDAS/getpagineodescarga');
API_ENDPOINTS.set('getcountcitassuspendidas', '/api/PGV/CITAS/SUSPENDIDAS/getcount');
API_ENDPOINTS.set('gettecnicosxcontrata_suspendidas', '/api/PGV/CITAS/SUSPENDIDAS/gettecnicosxcontrata');

// =============================================
// MAPA MOVIMIENTO TECNICOS
// =============================================
API_ENDPOINTS.set('getMovimientoTec', '/api/PGV/mapaMovimiento/getRutas');

// =============================================
// AGENDAR CITA POR ZONA
// =============================================
API_ENDPOINTS.set('getPosiblesFechasdeCitaxZona', '/api/agendarcita/getPosiblesFechasdeCitaxZona');
API_ENDPOINTS.set('obtenerCitasZonasEliminadas', '/api/agendarcita/obtenerCitasZonasEliminadas');
API_ENDPOINTS.set('obtenerCantCitasxZonasEliminadas', '/api/agendarcita/obtenerCantCitasxZonasEliminadas');
API_ENDPOINTS.set('getreportezona', '/api/agendarcita/getreportezona');
API_ENDPOINTS.set('getcontreportezona', '/api/agendarcita/getcontreportezona');

// =============================================
// CONFIGURACION ZONA
// =============================================
API_ENDPOINTS.set('getconfigprovincia', '/api/config/getconfigprovincia');
API_ENDPOINTS.set('getconfigdistritoxprovincia', '/api/config/getconfigdistritoxprovincia');
API_ENDPOINTS.set('getconfigcorregimientoxdistrito', '/api/config/getconfigcorregimientoxdistrito');
API_ENDPOINTS.set('getconfigtecnicoxzona', '/api/config/getconfigtecnicoxzona');
API_ENDPOINTS.set('updateconfigzonas', '/api/config/updateconfigzonas');

// =============================================
// REPORTES
// =============================================
API_ENDPOINTS.set('gettokenbi', '/api/PGV/REPORT/GET_TOKEN_BI');
API_ENDPOINTS.set('exportaradmindashcount', '/api/PGV/REPORT/EXPORTAR_ADMIN_DASH_COUNT');
API_ENDPOINTS.set('exportaradmindashlote', '/api/PGV/REPORT/EXPORTAR_ADMIN_DASH_LOTE');
API_ENDPOINTS.set('getubicacioncitas', '/api/PGV/REPORT/getubicacioncitas');
API_ENDPOINTS.set('updateUbicacionCita', '/api/PGV/REPORT/updateUbicacionCita');
API_ENDPOINTS.set('getCantRegistros', '/api/PGV/REPORT/getCantRegistros');
API_ENDPOINTS.set('getRegistros', '/api/PGV/REPORT/getRegistros');

API_ENDPOINTS.set('getreportezona_provincias', '/api/reporte/disp/getprovincia');
API_ENDPOINTS.set('getreportezona_distrito', '/api/reporte/disp/getdistritoxprovincia');
API_ENDPOINTS.set('getreportezona_corregimiento', '/api/reporte/disp/getcorregimientoxdistrito');
API_ENDPOINTS.set('getreportezona_tecnico', '/api/reporte/disp/gettecnicoxcorregimiento');
API_ENDPOINTS.set('getbitacoracliente', '/api/reporte/disp/getbitacoracliente');
API_ENDPOINTS.set('getClientesqueCancelaronCita', '/api/reporte/disp/getClientesqueCancelaronCita');
API_ENDPOINTS.set('getContClientesqueCancelaronCita', '/api/reporte/disp/getContClientesqueCancelaronCita');
API_ENDPOINTS.set('verificarAntesDeVolverALlamar', '/api/reporte/disp/verificarAntesDeVolverALlamar');
API_ENDPOINTS.set('getClientesqueCancelaronCitaxContrata', '/api/reporte/disp/getClientesqueCancelaronCitaxContrata');
API_ENDPOINTS.set('getContClientesqueCancelaronCitaxContrata', '/api/reporte/disp/getContClientesqueCancelaronCitaxContrata');
API_ENDPOINTS.set('getClientesFallaPersiste', '/api/reporte/disp/getClientesFallaPersiste');
API_ENDPOINTS.set('getContClientesFallaPersiste', '/api/reporte/disp/getContClientesFallaPersiste');
API_ENDPOINTS.set('getClientesFallaPersistexContrata', '/api/reporte/disp/getClientesFallaPersistexContrata');
API_ENDPOINTS.set('getContClientesFallaPersistexContrata', '/api/reporte/disp/getContClientesFallaPersistexContrata');

// =============================================
// MONITOREO
// =============================================
API_ENDPOINTS.set('getreporte1', '/api/PGV/monitoreo/getreporte1');
API_ENDPOINTS.set('getreporte2', '/api/PGV/monitoreo/getreporte2');
API_ENDPOINTS.set('getReporteDash', '/api/PGV/monitoreo/getReporteDash');
API_ENDPOINTS.set('getDetalleHora', '/api/PGV/monitoreo/getDetalleHora');
API_ENDPOINTS.set('getDetalleSubtipologia', '/api/PGV/monitoreo/getDetalleSubtipologia');
API_ENDPOINTS.set('getMonitoreoDescargaCount', '/api/PGV/monitoreo/getDescargaCount');
API_ENDPOINTS.set('getMonitoreoDescargaData', '/api/PGV/monitoreo/getDescargaData');
API_ENDPOINTS.set('getMonitoreoDescargaDedupCount', '/api/PGV/monitoreo/getDescargaDedupCount');
API_ENDPOINTS.set('getMonitoreoDescargaDedupData', '/api/PGV/monitoreo/getDescargaDedupData');

// =============================================
// SOCIAL MANAGER (Chat)
// =============================================
API_ENDPOINTS.set('getChatsSupervisor', '/api/socma/chats/supervisor');
API_ENDPOINTS.set('getcliente', '/api/socma/chats/getcliente');
API_ENDPOINTS.set('upsertfichacliente', '/api/socma/chats/upsertfichacliente');

// =============================================
// EQUIPO RECOLECTADO
// =============================================
API_ENDPOINTS.set('setestadoequipore', '/api/PGV/equiporecolector/setestado');
API_ENDPOINTS.set('getequipore', '/api/PGV/equiporecolector/pagineo');
API_ENDPOINTS.set('getcontequipore', '/api/PGV/equiporecolector/conteo');

// =============================================
// SEGUIMIENTO / CASOS WP
// =============================================
API_ENDPOINTS.set('getCasosWP', '/api/PGV/seguimiento/getCasosWP');
API_ENDPOINTS.set('insertCasosWP', '/api/PGV/seguimiento/insertCasosWP');

// =============================================
// PRIORIDAD
// =============================================
API_ENDPOINTS.set('getprioridades', '/api/PGV/PRIORIDAD/OBTENER');

// =============================================
// REPARACIONES / PLANTILLAS
// =============================================
API_ENDPOINTS.set('sendplantillascampana', '/api/reparaciones/sendplantillas');
API_ENDPOINTS.set('sendPlantillaCliente', '/api/reparaciones/sendPlantillaCliente');

// =============================================
// CITAS TENTATIVAS
// =============================================
API_ENDPOINTS.set('getCitaTentativaByCliente', '/api/v3/citas-tentativas/by-cliente');

// =============================================
// MARTECH
// =============================================
API_ENDPOINTS.set('insert_datos_idcaso_wex', '/ws/martech/insertidcasowex');
API_ENDPOINTS.set('insert_datos_gestiones', '/ws/martech/insertgestiones');

// =============================================
// CONTACTO / PROACTIVOS
// =============================================
API_ENDPOINTS.set('listarContacto', '/api/PGV/CONTACTO/LISTAR');
API_ENDPOINTS.set('listarContactoCount', '/api/PGV/CONTACTO/CONTEO');
API_ENDPOINTS.set('getContactoFibDetalle', '/api/PGV/CONTACTO/DETALLE');
API_ENDPOINTS.set('listarBitacoraProactivos', '/api/PGV/CONTACTO/BITACORA/LISTAR');
API_ENDPOINTS.set('contarBitacoraProactivos', '/api/PGV/CONTACTO/BITACORA/CONTEO');
API_ENDPOINTS.set('listarContactoDescarga', '/api/PGV/CONTACTO/LISTAR_DESCARGA');
API_ENDPOINTS.set('listarBitacoraProactivosDescarga', '/api/PGV/CONTACTO/BITACORA/LISTAR_DESCARGA');
API_ENDPOINTS.set('metricasContactoIsoft', '/api/PGV/CONTACTO/METRICAS');
API_ENDPOINTS.set('metricasContactoIsoftTiempos', '/api/PGV/CONTACTO/METRICAS/TIEMPOS');
API_ENDPOINTS.set('metricasContactoIsoftFlujo', '/api/PGV/CONTACTO/METRICAS/FLUJO');

// =============================================
// ENCUESTA
// =============================================
API_ENDPOINTS.set('sendPlantillasEncuesta', '/api/encuesta/sendPlantillasEncuesta');
API_ENDPOINTS.set('evaluarFallasEnvEncuesta', '/api/encuesta/evaluarFallasEnvEncuesta');
API_ENDPOINTS.set('getContPlantillasEncuestaaEnviar', '/api/encuesta/getContPlantillasEncuestaaEnviar');
API_ENDPOINTS.set('confirmacionEnvioEncuesta', '/api/encuesta/confirmacionEnvio');

// =============================================
// ALARMAS TP
// =============================================
API_ENDPOINTS.set('getalarmasxarea', '/api/PGV/ALARMAS/getalarmasxarea');
API_ENDPOINTS.set('getPendientes', '/api/PGV/alarmastp/pendientes');
API_ENDPOINTS.set('getHistAlarmasxAgente', '/api/PGV/alarmastp/getHistAlarmasxAgente');
API_ENDPOINTS.set('tomarAlarma', '/api/PGV/alarmastp/tomar');
API_ENDPOINTS.set('resolverAlarma', '/api/PGV/alarmastp/resolver');
API_ENDPOINTS.set('reintentoResolverAlarma', '/api/PGV/alarmastp/reintentoresolver');
API_ENDPOINTS.set('gestionarclienteahora', '/api/PGV/alarmastp/gestionarclienteahora');
API_ENDPOINTS.set('getReporteAlarmas', '/api/PGV/alarmastp/getReporteAlarmas');
API_ENDPOINTS.set('getContReporteAlarmas', '/api/PGV/alarmastp/getContReporteAlarmas');
API_ENDPOINTS.set('descargarReporteAlarmas', '/api/PGV/alarmastp/descargarReporteAlarmas');
API_ENDPOINTS.set('getPermisosAreaAlarmas', '/api/PGV/alarmastp/permisosArea');
API_ENDPOINTS.set('getTipologiasAlarmaPorCita', '/api/PGV/alarmastp/tipologiasArea');
API_ENDPOINTS.set('getAreasTransferibles', '/api/PGV/alarmastp/areasTransferibles');
API_ENDPOINTS.set('getTipologiasPorAreaAgente', '/api/PGV/alarmastp/tipologiasPorAreaAgente');
// Lista de idescenario visibles para la area del agente. Cacheada en frontend
// para filtrar el socket alarma-pendiente sin pegar al backend en cada evento.
API_ENDPOINTS.set('getEscenariosArea', '/api/PGV/alarmastp/escenariosArea');
API_ENDPOINTS.set('transferirAlarma', '/api/PGV/alarmastp/transferirAlarma');

// Admin: CRUD escenario_area (solo superadmin)
API_ENDPOINTS.set('escenarioAreaListar', '/api/PGV/escenario_area/listar');
API_ENDPOINTS.set('escenarioAreaListarAreas', '/api/PGV/escenario_area/listarAreas');
API_ENDPOINTS.set('escenarioAreaListarEscenarios', '/api/PGV/escenario_area/listarEscenarios');
API_ENDPOINTS.set('escenarioAreaCrear', '/api/PGV/escenario_area/crear');
API_ENDPOINTS.set('escenarioAreaActualizar', '/api/PGV/escenario_area/actualizar');
API_ENDPOINTS.set('escenarioAreaEliminar', '/api/PGV/escenario_area/eliminar');

// =============================================
// AUTO ASIGNACION CITAS LEJANAS (>5km)
// =============================================
API_ENDPOINTS.set('autoAsignLejListar', '/api/PGV/autoasignacitalejana/listar');
API_ENDPOINTS.set('autoAsignLejTomar', '/api/PGV/autoasignacitalejana/tomar');
API_ENDPOINTS.set('autoAsignLejTopCitas', '/api/PGV/autoasignacitalejana/topCitas');
API_ENDPOINTS.set('autoAsignLejCitasMapa', '/api/PGV/autoasignacitalejana/citasPendientesMapa');
API_ENDPOINTS.set('autoAsignLejAsignar', '/api/PGV/autoasignacitalejana/asignar');
API_ENDPOINTS.set('autoAsignLejCancelar', '/api/PGV/autoasignacitalejana/cancelar');
API_ENDPOINTS.set('autoAsignLejAnular', '/api/PGV/autoasignacitalejana/anular');
API_ENDPOINTS.set('autoAsignLejEsperarCercana', '/api/PGV/autoasignacitalejana/esperarCitaCercana');

// =============================================
// CRUCE SGO
// =============================================
API_ENDPOINTS.set('getCruceSGO', '/api/PGV/crucesgo/getCruceSGO');
API_ENDPOINTS.set('getContCruceSGO', '/api/PGV/crucesgo/getContCruceSGO');
API_ENDPOINTS.set('descargarCruceSGO', '/api/PGV/crucesgo/descargarCruceSGO');

// =============================================
// CERTIFICACION TELEFONIA
// =============================================
API_ENDPOINTS.set('getHistorialCertificado', '/api/PGV/CERTIFICACION_TELEFONIA/PAGINEO');
API_ENDPOINTS.set('getContHistorialCertificado', '/api/PGV/CERTIFICACION_TELEFONIA/CONTEO');
API_ENDPOINTS.set('getUsuariosCertificado', '/api/PGV/CERTIFICACION_TELEFONIA/USUARIOS');
API_ENDPOINTS.set('descargarHistorialCertificado', '/api/PGV/CERTIFICACION_TELEFONIA/DESCARGA');
API_ENDPOINTS.set('aprobarCertificado', '/api/PGV/CERTIFICACION_TELEFONIA/APROBAR');
API_ENDPOINTS.set('lookupIdCitaByOrden', '/api/PGV/CERTIFICACION_TELEFONIA/LOOKUP_IDCITA');

// =============================================
// PERMISOS / ROLES
// =============================================
API_ENDPOINTS.set('getcomentarioopciones', '/api/PGV/GESTION/GET_COMENTARIO_OPCIONES');
API_ENDPOINTS.set('obtenerbitacoracita', '/api/PGV/GESTION/OBTENER_BITACORA_CITA');
API_ENDPOINTS.set('gettecnicosbitacora', '/api/PGV/GESTION/GET_TECNICOS_BITACORA');
API_ENDPOINTS.set('historicobitacorageneral', '/api/PGV/GESTION/HISTORICO_BITACORA_GENERAL');
API_ENDPOINTS.set('getmodulosperm', '/api/PGV/PERMISOS/GET_MODULOS');
API_ENDPOINTS.set('getpermisos', '/api/PGV/PERMISOS/GET');
API_ENDPOINTS.set('saverolpermisos', '/api/PGV/PERMISOS/SAVE_ROL');
API_ENDPOINTS.set('updaterolpermisos', '/api/PGV/PERMISOS/UPDATE_ROL');
API_ENDPOINTS.set('deleterolpermisos', '/api/PGV/PERMISOS/DELETE_ROL');
API_ENDPOINTS.set('getrolespermisos', '/api/PGV/PERMISOS/GET_ROLES');
API_ENDPOINTS.set('getcontratasperm', '/api/PGV/PERMISOS/GET_CONTRATAS');
API_ENDPOINTS.set('getpermisoslogin', '/api/PGV/PERMISOS/LOGIN');
API_ENDPOINTS.set('getrolessupervisor', '/api/PGV/PERMISOS/ROLES_SUPERVISOR');
API_ENDPOINTS.set('getrolesagente', '/api/PGV/PERMISOS/ROLES_AGENTE');
API_ENDPOINTS.set('getidrolpermiso', '/api/PGV/PERMISOS/GET_IDROL_PERMISO');
API_ENDPOINTS.set('setidrolpermiso', '/api/PGV/PERMISOS/SET_IDROL_PERMISO');

// =============================================
// FALLAS PENDIENTES
// =============================================
API_ENDPOINTS.set('getFallasPendientesCount', '/api/PGV/FALLAS/getpendientescount');
API_ENDPOINTS.set('getFallasPendientesPagineo', '/api/PGV/FALLAS/getpendientespagineo');
// FALLAS DEPARTMENT WHITELIST
API_ENDPOINTS.set('getFallasDeptWhitelistListar', '/api/PGV/FALLAS/deptwhitelist/listar');
API_ENDPOINTS.set('getFallasDeptWhitelistCrear', '/api/PGV/FALLAS/deptwhitelist/crear');
API_ENDPOINTS.set('getFallasDeptWhitelistActualizar', '/api/PGV/FALLAS/deptwhitelist/actualizar');
API_ENDPOINTS.set('getFallasDeptWhitelistEliminar', '/api/PGV/FALLAS/deptwhitelist/eliminar');

// =============================================
// REASIGNACION POR AUSENCIA (RF-01 a RF-04)
// Ver: context/asignaciones/ADR-001-RF04-reporte-reasignaciones.md
// =============================================
API_ENDPOINTS.set('getReporteReasignaciones', '/api/PGV/reasignaciones/historial');
API_ENDPOINTS.set('getContReporteReasignaciones', '/api/PGV/reasignaciones/conteo');
API_ENDPOINTS.set('descargarReporteReasignaciones', '/api/PGV/reasignaciones/descarga');

// =============================================
// LOCACION — validación point-in-polygon contra polígonos cargados
// =============================================
API_ENDPOINTS.set('validarCoordsCorregimiento', '/api/PGV/LOCACION/VALIDAR_COORDS');
API_ENDPOINTS.set('statsPoligonos',             '/api/PGV/LOCACION/STATS_POLIGONOS');
API_ENDPOINTS.set('getPoligonoLocacion',        '/api/PGV/LOCACION/GET_POLIGONO');
API_ENDPOINTS.set('getConfigValidacionMapa',    '/api/PGV/LOCACION/GET_CONFIG_VALIDACION');
// Proxy de geocoding (Nominatim) — usado por el dialog del mapa.
API_ENDPOINTS.set('geocodeSearch',              '/api/PGV/LOCACION/GEOCODE');

// =============================================
// GARANTIA SERVICIO D2D (Door-to-Door)
// =============================================
API_ENDPOINTS.set('garantiaD2dListar',  '/api/PGV/GARANTIA_D2D/LISTAR');
API_ENDPOINTS.set('garantiaD2dCrear',   '/api/PGV/GARANTIA_D2D/CREAR');
API_ENDPOINTS.set('garantiaD2dTomar',   '/api/PGV/GARANTIA_D2D/TOMAR');
API_ENDPOINTS.set('garantiaD2dAtender', '/api/PGV/GARANTIA_D2D/ATENDER');
API_ENDPOINTS.set('garantiaD2dAnular',  '/api/PGV/GARANTIA_D2D/ANULAR');
API_ENDPOINTS.set('garantiaD2dListarServicios', '/api/PGV/GARANTIA_D2D/LISTAR_SERVICIOS');
API_ENDPOINTS.set('garantiaD2dListarProblemas', '/api/PGV/GARANTIA_D2D/LISTAR_PROBLEMAS');
API_ENDPOINTS.set('garantiaD2dGetCitaPorFalla', '/api/PGV/GARANTIA_D2D/GET_CITA_POR_FALLA');

// Bitacora tecnico
API_ENDPOINTS.set('bitacoraTecnicoTecnicos', '/api/PGV/BITACORA_TECNICO/TECNICOS');
API_ENDPOINTS.set('bitacoraTecnicoListar',   '/api/PGV/BITACORA_TECNICO/LISTAR');

// =============================================
// INFRUCTUOSA WHATSAPP (BRD 5.6)
// =============================================
API_ENDPOINTS.set('historialWhatsappInfructuosa', '/api/PGV/infructuosa-whatsapp/historial');
